export enum MenuItemSelectedVariant {
  Icon = 'ICON',
  BackgroundColor = 'BACKGROUND_COLOR',
}
